import { render, staticRenderFns } from "./ipList.vue?vue&type=template&id=31203e8a&scoped=true&"
import script from "./ipList.vue?vue&type=script&lang=js&"
export * from "./ipList.vue?vue&type=script&lang=js&"
import style0 from "./ipList.vue?vue&type=style&index=0&id=31203e8a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31203e8a",
  null
  
)

export default component.exports